// src/components/homepage_content/TopNav.js
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';

const TopNav = () => {
  const [position, setPosition] = useState(0);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const animationIdRef = useRef(null);

  const messages = useMemo(() => [
    "Welcome to DiceAce21 - Best Odds Guaranteed!",
    "Live Betting Available - Bet In-Play on All Sports",
    "Get 100% Welcome Bonus Up to $500!",
    "Secure & Fast Withdrawals - 24/7 Support",
    "Bet Anytime, Anywhere with Our Mobile App"
  ], []);

  const animateMarquee = useCallback(() => {
    if (!containerRef.current || !textRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    const textWidth = textRef.current.scrollWidth;

    setPosition(prev => {
      // If text has scrolled completely off screen left side
      if (prev < -textWidth) {
        // Move to next message
        setCurrentMessageIndex(prevIndex => 
          (prevIndex + 1) % messages.length
        );
        return containerWidth; // Reset to right side
      }
      
      // Move text left by 1px per frame (adjust for speed)
      return prev - 1;
    });

    // Continue animation
    animationIdRef.current = requestAnimationFrame(animateMarquee);
  }, [messages.length]);

  const startAnimation = useCallback(() => {
    if (!containerRef.current || !textRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    setPosition(containerWidth); // Start off-screen to the right

    // Start the animation
    animationIdRef.current = requestAnimationFrame(animateMarquee);
  }, [animateMarquee]);

  useEffect(() => {
    startAnimation();

    // Handle window resize
    const handleResize = () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
      startAnimation();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [startAnimation]);

  // Cleanup animation on unmount
  useEffect(() => {
    return () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
    };
  }, []);

  return (
    <div className="bg-blue-900 py-3 overflow-hidden border-b border-gray-700">
      <div 
        ref={containerRef}
        className="relative h-6 w-full"
        aria-live="polite"
        aria-label="Announcement ticker"
      >
        <span
          ref={textRef}
          className="absolute whitespace-nowrap text-sm font-medium text-blue-300 top-1/2 transform -translate-y-1/2 will-change-transform"
          style={{
            left: `${position}px`,
          }}
        >
          {messages[currentMessageIndex]}
        </span>
      </div>
    </div>
  );
};

export default TopNav;